import React, { ChangeEvent } from 'react';
import format from 'date-fns/format';
import { debounce } from 'lodash';
import Datepicker from '../../../../modules/datepicker/datepicker/datepicker';
import UiSearchInput from '../../../../modules/ui/ui-search-input/ui-search-input';
import './filters.scss';

interface IProps {
  setPeriod: React.Dispatch<
    React.SetStateAction<
      | {
          from?: string | undefined;
          to?: string | undefined;
        }
      | undefined
    >
  >;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
}

export default function Filters({ setPeriod, setSearch }: IProps) {
  const onPeriodChange = ({ dateFrom, dateTo }: Record<string, any>) => {
    const from = format(new Date(dateFrom), 'yyyy-MM-dd');
    const to = format(new Date(dateTo), 'yyyy-MM-dd');

    setPeriod({ from, to });
  };

  const onQueryChange = debounce((e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  }, 300);

  return (
    <div className="assets-tabs__filter">
      <div className="assets-tabs__filter--288">
        <UiSearchInput
          sm
          onChange={onQueryChange}
          placeholder="Поиск, организация, инн, сумма"
        />
      </div>
      <div className="assets-tabs__filter--224">
        <Datepicker
          sm
          type="range"
          onPeriodChange={(range) => {
            onPeriodChange({
              dateFrom: range.start?.toString() || '',
              dateTo: range.end?.toString() || '',
            });
          }}
        />
      </div>
    </div>
  );
}
